// import { Link } from "react-router-dom";
// import PeriodTable from "../../components/PeriodTable";

// const periodData = [
//     {
//         keyName: "H-1",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-2",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-3",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-4",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-5",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-6",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-7",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-8",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-9",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-10",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-11",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-12",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-13",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-14",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-15",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     }
// ];

// const periodDataTwo = [
//     {
//         keyName: "H-1",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-2",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-3",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-4",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-5",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-6",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-7",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-8",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-9",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-10",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-11",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-12",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-13",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-14",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     },
//     {
//         keyName: "H-15",
//         formula: "cost / (total_key_consumption × total_key_ponderation) × (consumption × ponderation)"
//     }
// ];

// const periodHeaders = ["Key Name", "Formula/Calculation Method", ""];

// const BuildingDetails = () => {
//     return (
//         <div className="admin-page building-details-page">
//             <div className="d-flex align-items-center justify-content-between mb-4">
//                 <div className="back-title d-flex align-items-center mb-0">
//                     <button className="back-btn-title"><i className="icon-icon-11"></i></button>
//                     <h3 className="page-section-title">Office Complex A</h3>
//                 </div>
//                 <button className="border-btns-copy"><i className="icon-icon-12"></i> Copy</button>
//             </div>
//             <div className="build-details-wrapper">
//                 <h4 className="build-box-title">Building Details</h4>
//                 <div className="build-details-card build-full-active">
//                     <div className="row">
//                         <div className="col-md-6">
//                             <ul>
//                                 <li>
//                                     <label>Building Name</label>
//                                     <p>Office Complex A</p>
//                                 </li>
//                                 <li>
//                                     <label>Owner Name</label>
//                                     <p>Mr. Rakesh Sharma</p>
//                                 </li>
//                                 <li>
//                                     <label>Property Type</label>
//                                     <p>Residential Apartment Complex</p>
//                                 </li>
//                             </ul>
//                         </div>
//                         <div className="col-md-6">
//                             <ul>
//                                 <li>
//                                     <label>Property Size</label>
//                                     <p>1,25,000 sq. ft.</p>
//                                 </li>
//                                 <li>
//                                     <label><i className="icon-icon-13"></i> Valid From</label>
//                                     <p>08/22/2022</p>
//                                 </li>
//                                 <li>
//                                     <label><i className="icon-icon-13"></i> Valid To</label>
//                                     <p>08/22/2025</p>
//                                 </li>
//                             </ul>
//                         </div>
//                         <p className="status active">Active</p>
//                     </div>
//                 </div>
//             </div>
//             <div className="build-details-wrapper">
//                 <h4 className="build-box-title">Addresses</h4>
//                 <div className="build-details-card">
//                     <ul>
//                         <li>
//                             <label>Property Address</label>
//                             <p>Flat No. 804, Tower A, Greenfield Heights, MG Road, Pune – 411045</p>
//                         </li>
//                         <li>
//                             <label>Building Address</label>
//                             <p>Flat No. 804, Tower A, Greenfield Heights, MG Road, Pune – 411045</p>
//                         </li>
//                         <li>
//                             <label>Managing Address</label>
//                             <p>Sunrise Property Management Pvt. Ltd., Office 302, Sky Business Park, Viman Nagar, Pune – 411014</p>
//                         </li>
//                     </ul>
//                 </div>
//             </div>
//             <div className="period-list">
//                 <div className="period-item">
//                     <div className="period-box-title d-flex align-items-center flex-wrap gap-3">
//                         <h4 className="build-box-title mb-0">Period</h4>
//                         <div className="period-date d-flex align-items-center">
//                             <p className="mb-0"><i className="icon-icon-13"></i> 08/22/2022</p>
//                             <span>to</span>
//                             <p className="mb-0"><i className="icon-icon-13"></i>08/22/2025</p>
//                         </div>
//                     </div>
//                     <div className="period-table-wrapper">
//                         <PeriodTable periods={periodData} headers={periodHeaders} />
//                     </div>
//                 </div>
//                 <div className="period-item">
//                     <div className="period-box-title d-flex align-items-center flex-wrap gap-3">
//                         <h4 className="build-box-title mb-0">Period</h4>
//                         <div className="period-date d-flex align-items-center">
//                             <p className="mb-0"><i className="icon-icon-13"></i> 08/22/2022</p>
//                             <span>to</span>
//                             <p className="mb-0"><i className="icon-icon-13"></i>08/22/2025</p>
//                         </div>
//                     </div>
//                     <div className="period-table-wrapper">
//                         <PeriodTable periods={periodDataTwo} headers={periodHeaders} />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default BuildingDetails;



import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";

const BuildingDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [building, setBuilding] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deletingPeriodId, setDeletingPeriodId] = useState(null);

  const fetchBuilding = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}building/details/${id}`, {
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.data?.status === "success") {
        setBuilding(res.data?.data);
      }
    } catch (err) {
      console.error("Error fetching building details:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchBuilding();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDeletePeriod = async (periodId, periodLabel) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete "${periodLabel}"?\n\nThis will permanently delete:\n• All keys and their configurations\n• All calculations\n• All imported data (costs, surfaces, consumptions, etc.)\n\nThis action cannot be undone.`
    );
    if (!confirmed) return;

    setDeletingPeriodId(periodId);
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_API_URL}building/${id}/period/${periodId}`,
        {
          headers: {
            "api-key": process.env.REACT_APP_API_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (res.data?.status === "success") {
        alert("Period deleted successfully!");
        fetchBuilding();
      } else {
        alert(res.data?.data || "Failed to delete period.");
      }
    } catch (err) {
      console.error("Error deleting period:", err);
      const errorMsg =
        err?.response?.data?.data || err?.response?.data?.message || "Failed to delete period.";
      alert(errorMsg);
    } finally {
      setDeletingPeriodId(null);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!building) return <p>No building found</p>;

  return (
    <div className="admin-page building-details-page">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div className="back-title d-flex align-items-center mb-0">
          <button className="back-btn-title" onClick={() => navigate(-1)}>
            <i className="icon-icon-11"></i>
          </button>
          <h3 className="page-section-title">{building?.building_name}</h3>
        </div>
        <Link to={`/buildings/edit/${building.id}`} className="border-btns-copy">
          <i className="icon-icon-12"></i> Edit Building
        </Link>
      </div>

      <div className="build-details-wrapper">
        <h4 className="build-box-title">Building Details</h4>
        <div className="build-details-card build-full-active">
          <div className="row">
            <div className="col-md-6">
              <ul>
                <li>
                  <label>Building Name</label>
                  <p>{building?.building_name}</p>
                </li>
                <li>
                  <label>Owner Name</label>
                  <p>{building?.owner_name}</p>
                </li>
                <li>
                  <label>Property Type</label>
                  <p>{building?.property_type}</p>
                </li>
              </ul>
            </div>
            <div className="col-md-6">
              <ul>
                <li>
                  <label>Property Size</label>
                  <p>{building?.building_size}</p>
                </li>
                <li>
                  <label>
                    <i className="icon-icon-13"></i> Valid From
                  </label>
                  <p>{new Date(building?.periods[0]?.start_date).toLocaleDateString()}</p>
                </li>
                <li>
                  <label>
                    <i className="icon-icon-13"></i> Valid To
                  </label>
                  <p>{new Date(building?.periods[0]?.end_date).toLocaleDateString()}</p>
                </li>
              </ul>
            </div>
            <p className={`status ${building?.is_active ? "active" : "inactive"}`}>
              {building?.is_active ? "Active" : "Inactive"}
            </p>
          </div>
        </div>
      </div>

      <div className="build-details-wrapper">
        <h4 className="build-box-title">Addresses</h4>
        <div className="build-details-card">
          <ul>
            <li>
              <label>Property Address</label>
              <p>{building?.property_address}</p>
            </li>
            <li>
              <label>Building Address</label>
              <p>{building?.building_address}</p>
            </li>
            <li>
            <label>Managing Address</label>
            {building?.managing_address
                ?.split("||")
                .filter(addr => addr.trim() !== "")
                .map((addr, idx) => (
                <p key={idx}>{addr}</p>
                ))}
            </li>
          </ul>
        </div>
      </div>

        <div className="period-list">
            {building?.periods?.length > 0 ? (
                building.periods.map((period, idx) => {
                  const periodLabel = `Period ${idx + 1} (${
                    period.start_date
                      ? new Date(period.start_date).toLocaleDateString("en-GB")
                      : "-"
                  } to ${
                    period.end_date
                      ? new Date(period.end_date).toLocaleDateString("en-GB")
                      : "-"
                  })`;
                  return (
                    <div className="period-item" key={period.id || idx}>
                        <div className="period-box-title d-flex align-items-center justify-content-between flex-wrap gap-3">
                          <div className="d-flex align-items-center flex-wrap gap-3">
                            <h4 className="build-box-title mb-0">Period {idx + 1}</h4>
                            <div className="period-date d-flex align-items-center">
                                <p className="mb-0">
                                <i className="icon-icon-13"></i>{" "}
                                {period.start_date
                                    ? new Date(period.start_date).toLocaleDateString("en-GB")
                                    : "-"}
                                </p>
                                <span>to</span>
                                <p className="mb-0">
                                <i className="icon-icon-13"></i>{" "}
                                {period.end_date
                                    ? new Date(period.end_date).toLocaleDateString("en-GB")
                                    : "-"}
                                </p>
                            </div>
                          </div>
                          <div className="button-group d-flex align-items-center">
                            <Link
                              to={`/buildings/edit/${building.id}?copyFromPeriodId=${period.id}`}
                              className="btns-table edit-btn"
                              title="Copy keys and data from this period"
                            >
                              <i className="icon-icon-12"></i>
                              {" "}
                              Copy Period
                            </Link>
                            {building.periods.length > 1 && (
                              <button
                                className="btns-table delete-btn"
                                onClick={() => handleDeletePeriod(period.id, periodLabel)}
                                disabled={deletingPeriodId === period.id}
                                title="Delete this period and all its data"
                              >
                                <i className="icon-icon-14"></i>
                                {" "}
                                {deletingPeriodId === period.id ? "Deleting..." : "Delete Period"}
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="period-table-wrapper">
                        {/* keep static formula table for now */}
                        {/* <PeriodTable periods={periodData} headers={periodHeaders} /> */}
                        </div>
                    </div>
                  );
                })
            ) : (
                <p>No periods available</p>
            )}
        </div>
    </div>
  );
};

export default BuildingDetails;
